import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

/** Listing agent block mirrors the on-screen Representation section. */
const Representation = ({ contract }: { contract?: Contract }) => {
  const agent = contract?.agentInfo;
  const mailing =
    agent?.street && agent?.city && agent?.state && agent?.zip
      ? `${agent.street}, ${agent.city}, ${agent.state} ${agent.zip}`
      : 'N/A';
  const rows: [string, unknown][] = [
    ['Agent Name', agent?.name],
    ['Email Address', agent?.sellerAgentEmail],
    ['Phone Number', agent?.sellerPhoneNumber],
    ['License Number', agent?.agentLicenseNumber],
    ['Company Name', agent?.agentCompanyName],
    ['Company License', agent?.agentCompanyLicense],
    ['Company State License', agent?.agentCompanyStateLicense],
    ['Company Address', agent?.agentCompanyAddress],
    ['Agent Mailing Address', mailing],
  ];
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Representation</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. All representations, claims, advertising, promotional activities,
          brochures or plans of any kind made by Seller, Brokers, Unbeatable
          Loans LLC, their licensees, employees, officers or partners are not a
          part of this Agreement unless expressly incorporated or stated in this
          Agreement. This Agreement contains the whole agreement between Seller
          and Buyer, and there are no other terms, obligations, covenants,
          representations, statements or conditions, oral or otherwise, of any
          kind whatsoever concerning this sale. This Agreement will not be
          altered, amended, changed or modified except in writing executed by
          the parties.
        </Text>

        <Text style={styles.listItem}>
          2. Unless otherwise stated in this Agreement, Buyer has inspected the
          Property (including fixtures and any personal property specifically
          listed herein) before signing this Agreement or has waived the right
          to do so, and agrees to purchase the Property in its present
          condition, subject to inspection contingencies elected in this
          Agreement. Buyer acknowledges that Brokers, their licensees,
          employees, officers or partners have not made an independent
          examination or determination of the structural soundness of the
          Property, the age or condition of the components, environmental
          conditions, the permitted uses, nor of conditions existing in the
          locale where the Property is situated; nor have they made a mechanical
          inspection of any of the systems contained therein.
        </Text>

        <Text style={styles.listItem}>
          3. Any repairs required by this Agreement will be completed in a
          workmanlike manner.
        </Text>

        <Text style={styles.listItem}>
          4. Broker(s) have provided or may provide services to assist
          unrepresented parties in complying with this Agreement.
        </Text>
      </View>

      <Text style={styles.subtitle}>
        LISTING AGENT/BROKER CONTACT AND LICENSE INFORMATION
      </Text>
      {rows.map(([label, value]) => (
        <Text key={label} style={styles.text}>
          <Text style={styles.bold}>{label}:</Text> {String(value || 'N/A')}
        </Text>
      ))}
    </View>
  );
};

export default Representation;
